module.exports = __webpack_public_path__ + "img/logomark_white.c86f9fb2.png";